import type { ProductEvents } from '@bizzdesign/shared/models';
import type { ProductAnalyticsService } from '@bizzdesign/shared/services';

export const sendAnalyticsEvent = (
  analyticsService: ProductAnalyticsService,
  eventName: ProductEvents,
  payload?: Record<string, unknown>,
) => {
  if (!payload) {
    analyticsService.sendEvent(eventName);
    return;
  }
  const filtered = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined),
  );
  if (Object.keys(filtered).length > 0) {
    analyticsService.sendEvent(eventName, filtered);
  } else {
    analyticsService.sendEvent(eventName);
  }
};
